import { useQuery } from "react-query";
import { useAuthContext } from "context/AuthContext";
import { getAcctOverview, getAccountCount, getAllEmailCampaignRevenue, getCampaignRevenue, getEmailMetrics, getInterfacePie, getPerformancePie, getSenderPie, getStatusTrendGraph, getSummaryPanel, getSummaryRevenue, getSummaryRevenueForVoice, getTemplateDistribution, getUsersCount, getVolumetricsPanel, getWAATemplateAnalyticsApi, getWASummaryPanel, getWhatsAppRevenueTrend, getWhatsAppStatusTrend, getWhatsAppTemplateTypes, getWhatsAppTotalRevenue, getSummarySmsRevenueData, getAgentsOverviewForRCS, getEmailVolPanelData, getAllRcsCampaignRevenue, getWAABusinessNumCounter, getAllRcsMessageType, getAllRcsScheduledCampaign, getAllRcsTotalRevenue, getAllRcsPostbackData, getWaRevenueByMonth, getSmsRevenueByMonth, getEmailRevenueByMonth, getRcsRevenueByMonth, getAllRcsSummarypanel, } from "lib/dashboard-apis";
const _options = {
    staleTime: 5 * 60 * 1000,
    retry: 1,
    retryDelay: 2 * 1000,
};
// Generic reusable hoo
const useDashboardQuery = (key, apiFn, { qKeys = [], options = {} }) => {
    const { userDetails } = useAuthContext();
    return useQuery([key, userDetails === null || userDetails === void 0 ? void 0 : userDetails.token, ...qKeys], apiFn, Object.assign(Object.assign({}, _options), options));
};
/**
 * Common args for all dashboard hooks
 *
 * @typedef {Object} DashboardHookArgs
 * @property {Array} [qKeys]   - Extra query keys to differentiate cache
 * @property {Object} [options] - Extra react-query options
 */
// Thin wrappers
export const useAcctOverview = (arg) => useDashboardQuery("accountOverview", getAcctOverview, arg);
/**
 * Hook to get volumetrics panel
 * @param {DashboardHookArgs} arg
 */
export const useVolumetricsPanel = (arg) => useDashboardQuery("volumetricsPanel", getVolumetricsPanel, arg);
export const useRCSSummaryPanel = (arg) => useDashboardQuery("volumetricsPanel", getAllRcsSummarypanel, arg);
/**
 * Hook to get campaign revenue
 * @param {DashboardHookArgs} arg
 */
export const useCampaignRevenue = (arg) => useDashboardQuery("revenueData", getCampaignRevenue, arg);
export const useScheduleCampaignData = (arg) => useDashboardQuery("scheduleCampaignData", getAllRcsScheduledCampaign, arg);
export const useRCSTotalRevenue = (arg) => useDashboardQuery("totalRevenueData", getAllRcsTotalRevenue, arg);
export const usePostbackData = (arg) => useDashboardQuery("postbackData", getAllRcsPostbackData, arg);
export const useStatTrendData = (arg) => useDashboardQuery("statTrendData", getStatusTrendGraph, arg);
export const useSummarySmsRevenueData = (arg) => useDashboardQuery("SummarySmsRevenueData", getSummarySmsRevenueData, arg);
export const useAgentsOverviewForRCS = (arg) => useDashboardQuery("agentsOverviewForRcs", getAgentsOverviewForRCS, arg);
/**
 * Hook to get accounts count
 * @param {DashboardHookArgs} arg
 */
export const useAccountsCountData = (arg) => useDashboardQuery("accountsCount", getAccountCount, arg);
/**
 * Hook to get users count
 * @param {DashboardHookArgs} arg
 */
export const useUsersCount = (arg) => useDashboardQuery("usersCount", getUsersCount, arg);
/**
 * Hook to get all channel summary panel
 * @param {DashboardHookArgs} arg
 */
export const useAllChannelSummaryPanelData = (arg) => useDashboardQuery("summaryPanel", getSummaryPanel, arg);
export const useEmailVolPanelData = (arg) => useDashboardQuery("getEmailVolPanelData", getEmailVolPanelData, arg);
/**
 * Hook to get whatsapp total revenue
 * @param {DashboardHookArgs} arg
 */
export const useAllChannelWaRevenueData = (arg) => useDashboardQuery("getWhatsAppTotalRevenue", getWhatsAppTotalRevenue, arg);
/**
 * Hook to get Whatsapp summary panel
 * @param {DashboardHookArgs} arg
 */
export const useAllChannelWaSummaryPanelData = (arg) => useDashboardQuery("waSummaryPanel", getWASummaryPanel, arg);
export const useAllChannelRcsSummaryPanel = (arg) => useDashboardQuery("getAllRcsSummarypanel", getAllRcsSummarypanel, arg);
export const useAllChannelRcsCampaignRevenue = (arg) => useDashboardQuery("getAllRcsCampaignRevenue", getAllRcsTotalRevenue, arg);
/**
 * Hook to get senders pie chart data
 * @param {DashboardHookArgs} arg
 */
export const useAllChannelSenderPieData = (arg) => useDashboardQuery("getSenderPie", getSenderPie, arg);
/**
 * Hook to get interface pie chart data
 * @param {DashboardHookArgs} arg
 */
export const useAllChannelInterFacePieData = (arg) => useDashboardQuery("interfacePie", getInterfacePie, arg);
/**
 * Hook to get performance pie chart data
 * @param {DashboardHookArgs} arg
 */
export const usePerformancePieData = (arg) => useDashboardQuery("performancePie", getPerformancePie, arg);
/**
 * Hook to get summary revenue
 * @param {DashboardHookArgs} arg
 */
export const useAllChannelSummaryRevenueData = (arg) => useDashboardQuery("getSummaryRevenue", getSummaryRevenue, arg);
/**
 * Hook to get email revenue
 * @param {DashboardHookArgs} arg
 */
export const useEmailCampRevenueData = (arg) => useDashboardQuery("emailrevenueData", getAllEmailCampaignRevenue, arg);
/**
 * Hook to get voice summary revenue
 * @param {DashboardHookArgs} arg
 */
export const useAllChannelSummaryRevenueVoiceData = (arg) => useDashboardQuery("getSummaryRevenueForVoice", getSummaryRevenueForVoice, arg);
/**
 * Hook to get dashboard status trend
 * @param {DashboardHookArgs} arg
 */
export const useStatusTrendData = (arg) => useDashboardQuery("getStatusTrend", getStatusTrendGraph, arg);
export const useRevenueByMonth = (arg, channel) => {
    var _a, _b;
    const log = (x, ...y) => console.log(`useRevenueByMonth:-${x}`, ...y);
    const ch = channel === null || channel === void 0 ? void 0 : channel.toLowerCase();
    const config = {
        whatsapp: {
            key: "getWaRevenueByMonth",
            fn: getWaRevenueByMonth,
        },
        sms: {
            key: "getSmsRevenueByMonth",
            fn: getSmsRevenueByMonth,
        },
        rcs: {
            key: "rcsRevenueByMonth",
            fn: getRcsRevenueByMonth,
        },
        email: {
            key: "eRevenueByMonth",
            fn: getEmailRevenueByMonth,
        },
    };
    const selected = config[ch];
    if (!selected) {
        log(`Unknown Channel: ${channel}`);
    }
    return useDashboardQuery((_a = selected === null || selected === void 0 ? void 0 : selected.key) !== null && _a !== void 0 ? _a : "unknownRevenueByMonth", (_b = selected === null || selected === void 0 ? void 0 : selected.fn) !== null && _b !== void 0 ? _b : (() => Promise.resolve(null)), arg);
};
/**
 * Hook to get email metrics
 * @param {DashboardHookArgs} arg
 */
export const useEmailMetricsData = (arg) => useDashboardQuery("emailMetricsData", getEmailMetrics, arg);
/**
 * Hook to get whatsapp account business number counter
 * @param {DashboardHookArgs} arg
 */
export const useWaABusinessNumCounter = (arg) => useDashboardQuery("WaABusinessNumCounter", getWAABusinessNumCounter, arg);
/**
 * Hook to get whatsapp account template analytics data
 * @param {DashboardHookArgs} arg
 */
export const useWaATemplateAnalyticsApi = (arg) => useDashboardQuery("WAATemplateAnalyticsRes", getWAATemplateAnalyticsApi, arg);
/**
 * Hook to get whatsapp template distribution data
 * @param {DashboardHookArgs} arg
 */
export const useWaTemplateDistribution = (arg) => useDashboardQuery("WaTemplateDistribution", getTemplateDistribution, arg);
/**
 * Hook to get whatsapp template types data
 * @param {DashboardHookArgs} arg
 */
export const useWaTemplateTypes = (arg) => useDashboardQuery("WaTemplateTypes", getWhatsAppTemplateTypes, arg);
export const useRCSMessageTypes = (arg) => useDashboardQuery("RCSMessageTypes", getAllRcsMessageType, arg);
/**
 * Hook to get whatsapp revenue | usage trend data
 * @param {DashboardHookArgs} arg
 */
export const useWhatsAppRevenueTrend = (arg) => useDashboardQuery("getWhatsAppRevenueTrend", getWhatsAppRevenueTrend, arg);
/**
 * Hook to get whatsapp message trend data
 * @param {DashboardHookArgs} arg
 */
export const useWhatsAppMessageTrend = (arg) => useDashboardQuery("getWhatsAppMessageTrend", getWhatsAppStatusTrend, arg);
